import React, { useContext } from 'react';
import { useDispatch } from "react-redux";

import ActionButton from "../../../../Components/Buttons/ActionButton";
import { deleteBooking } from "../../Requests/BookingListRequests";
import { TabContext } from "../../Pages/BookingsLog";
import { UPDATE } from "../../Bookings";

const DeleteBookingButton = (props) => {
    const dispatch = useDispatch();
    const tabState = useContext(TabContext);

    const getMenuItems = () => {
        return (props.booking.recurrence_id)
            ? {
                [UPDATE.SINGLE]: 'Delete Single Occurrence',
                [UPDATE.SERIES]: 'Delete Series',
            }
            : null;
    }

    const getMenuConfirmationText = () => {
        return (props.booking.recurrence_id)
            ? {
                [UPDATE.SINGLE]: {
                    title: "Delete this booking",
                    text: "<p>Are you sure you want to delete this booking occurrence?</p>"
                },
                [UPDATE.SERIES]: {
                    title: "Delete all bookings in series",
                    text: "<p>Are you sure you want to delete all past or cancelled bookings that are part of this series?</p>"
                },
            }
            : {
                title: "Delete Booking",
                text: "<p>Are you sure you want to delete this booking?</p>"
            };
    }

    const handleDelete = (updateType = UPDATE.SINGLE) => {
        dispatch(
            deleteBooking(props.booking.id, tabState.view, updateType)
        );
    }

    if (!props.booking || !props.booking.can_delete) {
        return null;
    }

    return (
        <ActionButton
            icon="fa-trash"
            onClick={(evt) => handleDelete(UPDATE.SINGLE)}
            onMenuItemClick={(updateType) => { handleDelete(updateType) }}
            menuItems={getMenuItems()}
            confirmationText={getMenuConfirmationText()}
        />
    )
}

export default DeleteBookingButton;
